import { LABEL_URL, BELIEVE_CONTROLLER_URL, DISTRIBUTION_URL, MODIFICATION_URL } from "../../../../services/common-urls";
import { MHTTPCL, JSON_STRING, createHttpGetOptions } from "../../../../services/http/http-client";

export const statementServices = {


    home: () => MHTTPCL.get(LABEL_URL, {
        section: "royalty",
        action: "home",
        home_template: "label_statements",
        output: JSON_STRING

    }),


    royaltyStatementsTab: () => MHTTPCL.get(LABEL_URL, {
        section: "royalty",
        action: "royalty_statements_tab"
    }),

    believeStatements: (start, end, search_term, period) => MHTTPCL.post(BELIEVE_CONTROLLER_URL, {
        action: "royalty_statements",
        start: start,
        end: end,
        search_term: search_term,
        period: period
    }),
    royaltyPeriodStatementTabBelieve: (royalty_period_id, royalty_period_bundle_id) => MHTTPCL.post(BELIEVE_CONTROLLER_URL, {
        action: "royalty_period_statement_tab",
        section: "royalty",
        royalty_period_id: royalty_period_id,
        royalty_period_bundle_id: royalty_period_bundle_id
    }),

    royaltyPeriodStatementTab: (royalty_period_id, royalty_period_bundle_id) => MHTTPCL.post(LABEL_URL, {
        action: "royalty_period_statement_tab",
        section: "royalty",
        royalty_period_id: royalty_period_id,
        royalty_period_bundle_id: royalty_period_bundle_id
    }),

    updateRoyaltyPeriodPayment: (royalty_period_id) => MHTTPCL.post(LABEL_URL, {
        section: "royalty",
        action: "update_royalty_period_payment",
        royalty_period_id: royalty_period_id,
        royalty_period_bundle_id: ""
    }),

    cleanShopNames: () => MHTTPCL.post(DISTRIBUTION_URL, {
        section: "reports",
        action: "clean_shop_names"
    }),

    exportStatements: ({ search = "", period = "", royalty_period = "", invoice_project = "", statement_type = "" }) => MHTTPCL.postJSONasFormData(LABEL_URL, {
        section: "royalty",
        action: "export_statements",
        search: search,
        period: period,
        royalty_period: royalty_period,
        invoice_project: invoice_project,
        statement_type: statement_type



    }, createHttpGetOptions({ responseType: 'blob' })),

    confirmAllAccountRoyaltyDatesEstimation: () => MHTTPCL.post(LABEL_URL, {
        action: "confirm_royalty_dates_estimation",
        section: "royalty"
    }),
    confirmAllAccountRoyaltyDates: () => MHTTPCL.post(LABEL_URL, {
        action: "confirm_all_account_royalty_dates",
        section: "royalty"
    }),
    checkConfirmRoyaltyDates: () => MHTTPCL.post(LABEL_URL, {
        action: "check_confirm_royalty_dates",
        section: "royalty"
    }),

    missingContractsProducts: () => MHTTPCL.post(LABEL_URL, {
        section: "royalty",
        action: "missing_contracts_products"
    }),

    emailStatementsModal: () => MHTTPCL.post(BELIEVE_CONTROLLER_URL, {
        action: "email_statements_modal"
    }),

    emailStatementsRas: (deal_type_id, search_term) => MHTTPCL.post(BELIEVE_CONTROLLER_URL, {
        action: "email_statements_ras",
        deal_type_id: deal_type_id,
        search_term: search_term
    }),

    batchStatementFilter: () => MHTTPCL.get(LABEL_URL, {
        section: "royalty",
        action: "batch_statement_filter",
        output: JSON_STRING
    }),

    searchBatchAccounts: (label_status_id = "", invoice_project_id = "", royalty_period = "", release_id = "") => MHTTPCL.post(LABEL_URL, {
        section: "royalty",
        action: "search_batch_accounts",
        label_status_id: label_status_id,
        invoice_project_id: invoice_project_id,
        royalty_period: royalty_period,
        release_id: release_id,
        output: JSON_STRING
    }),
    get_statements_status: (start_date, end_date) => MHTTPCL.post(LABEL_URL, {
        section: "royalty",
        action: "get_statements_status",
        start_date,
        end_date,
    }),
    create_batch_statements: (data) => {
        // console.log({'statements.service.js:118 JSON.stringify(data)' : JSON.stringify(data)});
        return MHTTPCL.post(LABEL_URL, {
            section: "royalty",
            action: "create_batch_statements",
            data: JSON.stringify(data),
        })
    },
    statementPaymentsTab: (limit_start, limit_end, search_str, search_status) => MHTTPCL.post(BELIEVE_CONTROLLER_URL, {
        action: "statement_payments_tab",
        limit_start: limit_start,
        limit_end: limit_end,
        search_str: search_str,
        search_status: search_status
    }),
    addProductsToContracts: (products) => MHTTPCL.post(LABEL_URL, {
        section: "royalty",
        action: "add_products_to_contracts",
        products: JSON.stringify(products),
        output: JSON_STRING
    }),

    statementPaymentsTabUndoPayment: (payment_id) => MHTTPCL.post(LABEL_URL, {
        action: "statement_payments_tab_undo_payment",
        payment_id: payment_id
    }),

    ModifyPayments: (kVal, payment_date, matching_date, payment_amount, payment_external_ref) => MHTTPCL.post(MODIFICATION_URL, {
        modify_type: "record",
        table: "payments",
        kVal: kVal,
        payment_date: payment_date,
        matching_date: matching_date,
        payment_amount: payment_amount,
        payment_external_ref: payment_external_ref
    }),

    updateShopNames: () => MHTTPCL.post(DISTRIBUTION_URL, {
        section: "reports",
        action: "update_shop_names"
    }),

    //berlin3   
    // emailStatements:(reset_login,ra_ids)=>MHTTPCL.post(BELIEVE_CONTROLLER_URL,{
    //     action	: "email_statements",
    //     reset_login:reset_login,
    //     ra_ids:	ra_ids
    // }),
    emailStatements: (royalty_period_ids, royalty_period_bundle_ids, cc, bcc) => MHTTPCL.post(LABEL_URL, {
        section: "royalty",
        action: "email_statements",
        royalty_period_ids: JSON.stringify(royalty_period_ids),
        royalty_period_bundle_ids: JSON.stringify(royalty_period_bundle_ids),
        cc: cc,
        bcc: bcc
    }),



    believeReportFileUrls: (royalty_period_id) => MHTTPCL.post(BELIEVE_CONTROLLER_URL, {
        action: "believe_report_file_urls",
        royalty_period_id: royalty_period_id,
        expire_in_seconds: "500",
        output: JSON_STRING
    }),

    filterStatements: (search = "", period = "", royalty_period = "", invoice_project = "", statement_type = "") => MHTTPCL.get(LABEL_URL, {
        search: search,
        period: period,
        royalty_period: royalty_period,
        invoice_project: invoice_project,
        statement_type: statement_type,
        section: "royalty",
        action: "filter_statements",
        output: JSON_STRING

    }),

    royaltyStatementPage: (startrow) => MHTTPCL.post(LABEL_URL, {
        section: "royalty",
        action: "royalty_statement_page",
        startrow: startrow,
        output: JSON_STRING
    }),

    rsAdvanceSearchModal: () => MHTTPCL.post(BELIEVE_CONTROLLER_URL, {
        action: "rs_advance_search_modal"
    }),
    rsDefaultAdvanceSearchModal: () => MHTTPCL.post(LABEL_URL, {
        action: "advance_search_statements_modal_data",
        section: "royalty",
    }),
    royaltyStatements: ({ start, royalty_account_id, deal_id, period, royalty_period, invoice_project_id, company_id, label_status_id, table_name, deal_type_ids }) => MHTTPCL.post(BELIEVE_CONTROLLER_URL, {
        action: "royalty_statements",
        start: start,
        royalty_account_id: royalty_account_id,
        deal_id: deal_id,
        period: period,
        royalty_period: royalty_period,
        invoice_project_id: invoice_project_id,
        company_id: company_id,
        label_status_id: label_status_id,
        table_name: table_name,
        deal_type_ids: deal_type_ids
    }),
    advanceSearchStatements: ({ rowStart, royalty_account_id,
        periods,
        royalty_period,
        invoice_project_ids,
        label_status_ids,
        period_type,
        amount_start,
        amount_end,
        start,
        end,
        year,
        locked,
        release_id,
        send_out,
        pdf }) => MHTTPCL.post(LABEL_URL, {
            action: "advance_search_statements",
            section: "royalty",
            royalty_account_id: royalty_account_id,
            periods: periods,
            royalty_period: royalty_period,
            invoice_project_ids: invoice_project_ids,
            label_status_ids: label_status_ids,
            period_type: period_type,
            amount_start: amount_start,
            amount_end: amount_end,
            end: end,
            release_id: release_id,
            start: start,
            locked: locked,
            send_out: send_out,
            pdf: pdf,
            year: year
        }),

    searchAccounts: (search) => MHTTPCL.get(LABEL_URL, {
        section: "royalty",
        action: "search_accounts",
        search: search
    }),

    searchIdProds: (search) => MHTTPCL.get(BELIEVE_CONTROLLER_URL, {
        action: "search_id_prods",
        search: search
    }),

    emptyStatementLog: (royalty_period_id, royalty_period_bundle_id = "") => MHTTPCL.post(LABEL_URL, {
        action: "empty_statement_log",
        section: "royalty",
        royalty_period_id: royalty_period_id,
        royalty_period_bundle_id: royalty_period_bundle_id
    }),

    createInvoice: (royalty_period_id, royalty_period_bundle_id = "") => MHTTPCL.post(LABEL_URL, {
        action: "create_invoice",
        section: "royalty",
        royalty_period_id: royalty_period_id,
        royalty_period_bundle_id: royalty_period_bundle_id
    }),

    modifyStatementTaxDeduction: (royalty_period_id, royalty_period_bundle_id = "", tax_type_id_deduction) => MHTTPCL.post(LABEL_URL, {
        action: "modify_statement_tax_deduction",
        section: "royalty",
        royalty_period_id: royalty_period_id,
        royalty_period_bundle_id: royalty_period_bundle_id,
        tax_type_id_deduction: tax_type_id_deduction
    }),

    modifyStatementVatRate: ({ royalty_period_id, royalty_period_bundle_id = "", vat_rate }) => MHTTPCL.post(LABEL_URL, {
        action: "modify_statement_vat_rate",
        section: "royalty",
        royalty_period_id: royalty_period_id,
        royalty_period_bundle_id: royalty_period_bundle_id,
        vat_rate: vat_rate
    }),





    swapPaymentClosing: (royalty_period_id, royalty_period_bundle_id = "") => MHTTPCL.post(LABEL_URL, {
        action: "swap_payment_closing",
        section: "royalty",
        royalty_period_id: royalty_period_id,
        royalty_period_bundle_id: royalty_period_bundle_id
    }),


    emailStatementsFormData: ({royalty_period_ids,search,
        period,
        royalty_period,
        invoice_project,
        statement_type }) => MHTTPCL.post(LABEL_URL, {
        section: "royalty",
        action: "email_statements_form_data",
        royalty_period_ids,
        search,
        period,
        royalty_period,
        invoice_project,
        statement_type
    }),



    //:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::://

    confirmRoyaltyDatesEstimation: () => MHTTPCL.post(LABEL_URL, {
        section: "royalty",
        action: "confirm_royalty_dates_estimation",
        output: JSON_STRING
    }),

    confirmAllAccountRoyaltyDatesV2: () => MHTTPCL.post(LABEL_URL, {
        section: "royalty",
        action: "confirm_all_account_royalty_dates_v2"
    }),

    //::::::::::::::::::::::::::::::::DELETE::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::://
    countRoyaltyPeriodPayment: (royalty_period_id) => MHTTPCL.post(LABEL_URL, {
        section: "royalty",
        action: "count_royalty_period_payment",
        royalty_period_id: royalty_period_id,
        royalty_period_bundle_id: ""
    }),

    royaltyPeriodInvoiceInfo: (royalty_period_id) => MHTTPCL.post(LABEL_URL, {
        section: "royalty",
        action: "royalty_period_invoice_info",
        royalty_period_id: royalty_period_id
    }),

    removeRoyaltyPeriod: (royalty_period_id) => MHTTPCL.post(LABEL_URL, {
        section: "royalty",
        action: "remove_royalty_period",
        royalty_period_id: royalty_period_id
    }),
    raExternalUserLinks: (royalty_account_id) => MHTTPCL.post(LABEL_URL, {
        section: "royalty",
        action: "ra_external_user_links",
        royalty_account_id: royalty_account_id
    })






















































    //     action	"email_statements"
    // reset_login	"0"
    // ra_ids	"[\"104\"]"











}



